<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="publishStatusSlot" slot-scope="{ row }">
        <el-button @click="showPublishSpeed(row)" type="link" v-if="row.publishStatus == 0">{{publish_status_map[row.publishStatus]}}</el-button>
        <span v-else>{{publish_status_map[row.publishStatus]}}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "startTime", attrs: { label: "删除时间" } },
        { prop: "channel", attrs: { label: "资料类型" } },
        { prop: "staffName", attrs: { label: "操作人" }},
        { prop: "total", attrs: { label: "删除数量" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
    };
  },
  computed: {
    ...mapGetters(['routerPrefix']),
    publish_status_map() {
      const { PUBLISH_STATUS_MAP }  = prod_center_dictionary;
      return PUBLISH_STATUS_MAP;
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    jumpDetail(rowData) {
       this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id
          }
      })
    },
    showPublishSpeed(rowData) {
      this.setCurrentPage(`${this.routerPrefix}log`);
      this.publishSpeed({publishType: rowData.publishType, resultVisible: true})
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
